import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Ensure this is imported
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";
import TimeIconUnniversal from "../../assets/images/icons/TimeIconUniversal.svg";
const TimePickerComponent = ({
  value = null,
  onChange,
  className = "",
  placeholder = "",
  error = "",
  mandatory = false,
  label = "",
  helperText = "",
  id,
  autoFocus = false,
  size = "small",
  ...props
}) => {
  const [touched, setTouched] = useState(false);
  const [errorText, setErrorText] = useState(error);
  const inputRef = useRef(null); // Reference to the input field

  useEffect(() => {
    setErrorText(error);
  }, [error]);

  const handleInputBlur = () => {
    setTouched(true);
    if (!value) {
      setErrorText("Please select a time");
    } else {
      setErrorText("");
    }
  };

  // Automatically focus the input if there's an error or if autoFocus is set
  //   useEffect(() => {
  //     if (autoFocus && inputRef.current) {
  //       inputRef.current.focus();
  //     }
  //     if (errorText && inputRef.current) {
  //       inputRef.current.focus(); // Focus on the input when error occurs
  //     }
  //   }, [errorText, autoFocus]);
  const handleIconClick = (e) => {
    e.stopPropagation();
    if (inputRef.current) {
      inputRef.current.querySelector("input").click(); // Focus on the input inside the DatePicker
    }
  };

  const dynamicClass = () => {
    if (size === "small") {
      return "px-[0.4rem] py-[0.3rem] text-[0.8rem] h-[25px]";
    } else if (size === "medium") {
      return "px-3 py-1 text-[0.9rem] h-[30px]";
    } else if (size === "large") {
      return "px-3 py-1 text-[0.9rem] h-[38px]";
    }
  };

  return (
    <div className={`flex flex-col ${className} w-full`} role="form">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1" aria-label={label}>
          {label}
        </label>
      )}
      <div className="relative bg-container-datepicker" ref={inputRef}>
        <DatePicker
          ref={inputRef} // Attach the ref to the time picker input
          selected={value}
          onChange={onChange}
          placeholderText={placeholder}
          className={`w-full border rounded-md ${
            mandatory && ((touched && !value) || errorText) && !value
              ? "border-[#EF4444] focus:ring-[#EF4444] focus:border-[#EF4444]"
              : "border-gray-300 focus:ring-0 focus:border-[#7A7D84]"
          }  ${dynamicClass()}  `}
          id={id}
          aria-invalid={errorText ? "true" : "false"}
          aria-describedby={(helperText && touched && !value) || errorText ? `${id}-helper` : undefined}
          {...props}
          showTimeSelect // Enable time picker
          showTimeSelectOnly // Only show time picker (no date)
          timeIntervals={15} // Time intervals of 15 minutes
          timeFormat="HH:mm" // Use 24-hour time format
          dateFormat="HH:mm" // Display time in the input field (HH:mm)
          onBlur={handleInputBlur}
          tabIndex={0}
          autoFocus={autoFocus} // Focus the input field on page load if required
          popperPlacement="bottom-end" // Position the dropdown to the right
        />
        <button
          type="button"
          className={`absolute right-[1px] top-1/2 transform -translate-y-1/2  ${size === "small" ? "px-[0.5rem] py-[0.45rem]" : "px-[0.6rem] py-[0.5rem]"} bg-gray-100 rounded-r-lg`}
        >
          <img
            src={TimeIconUnniversal} // Add your calendar icon path
            alt="Calendar Icon"
            className={`${size === "small" ? "h-[10px] w-[10px]" : "h-[14px] w-[14px]"} cursor-pointer`}
            onClick={handleIconClick} // Focus the input on icon click
          />
        </button>
      </div>
      {Boolean(mandatory) && helperText && ((touched && !value) || errorText) && (
        <span
          id={`${id}-helper`}
          className="flex gap-1 items-center text-xs text-gray-500 ms-1 text-[#BF2315] text-[10px]"
          role="alert"
          aria-live="assertive"
        >
          <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
          {helperText}
        </span>
      )}
    </div>
  );
};

export default TimePickerComponent;
